import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import type { ReactNode } from 'react';

interface ProtectedRouteProps {
    children: ReactNode;
}

// Paths that require onboarding to be completed
const ONBOARDING_REQUIRED_PATHS = ['/assets', '/debts', '/dashboard'];

function requiresOnboarding(pathname: string): boolean {
    return ONBOARDING_REQUIRED_PATHS.some(
        (path) => pathname === path || pathname.startsWith(`${path}/`)
    );
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { isAuthenticated, isLoading, needsOnboarding } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="flex min-h-screen items-center justify-center">
                <div className="text-gray-500">Loading...</div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Redirect to onboarding if needed and on a path that requires it
    if (needsOnboarding && requiresOnboarding(location.pathname)) {
        return <Navigate to="/onboarding" replace />;
    }

    return <>{children}</>;
}
